import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'
import { formatadores } from 'src/paginas/aluno/painel-financeiro/pagina-financeiro/formatadores'

export const colunaFimPeriodoInscricaoTCC = (): TabelaColuna => ({
  Chave: 'fimPeriodoInscricaoTCC',
  ComOrdenacao: true,
  Renderizar: (linha: TabelaDados) => (
    <span>{formatadores.dataLocaleString(linha.fimPeriodoInscricaoTCC)}</span>
  ),
  RenderizarCabecalho: () => (
    <div style={{ width: 90 }}>Fim Período Insc. TCC</div>
  )
})
